import {
  SET_TRAJET_REPORT_BREADCRUMB_DATA,
  SET_TRAJET_REPORT_FUNNEL_CHART_DATA,
  SET_TRAJET_REPORT_LEAD_DATA,
  SET_TRAJET_REPORT_LEAD_DETAIL_DATA,
  SET_TRAJET_REPORT_LEAD_HISTORY_TABLE_DATA,
  SET_TRAJET_REPORT_LOV_DATA,
  SET_TRAJET_REPORT_TEAM_DATA,
  SET_TRAJET_REPORT_TEAM_LEAD_ASSIGNED_DATA,
} from '@stores/trajetReport/constants.js';

export const initialState = {
  teamData: {},
  leadData: {},
  leadDetailData: {},
  leadHistoryTableData: {
    number: 0,
    size: 0,
    totalElements: 0,
    totalPages: 0,
    numberOfElements: 0,
    content: [],
  },
  funnelChartData: {},
  breadcrumbData: {},
  lov: {},
  teamLeadAssigned: 0,
};

const trajetReportReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_TRAJET_REPORT_TEAM_DATA:
      state = {
        ...state,
        teamData: payload,
      };
      break;
    case SET_TRAJET_REPORT_LEAD_DATA:
      state = {
        ...state,
        leadData: payload,
      };
      break;
    case SET_TRAJET_REPORT_LEAD_DETAIL_DATA:
      state = {
        ...state,
        leadDetailData: payload,
      };
      break;
    case SET_TRAJET_REPORT_LEAD_HISTORY_TABLE_DATA:
      state = {
        ...state,
        leadHistoryTableData: payload,
      };
      break;
    case SET_TRAJET_REPORT_FUNNEL_CHART_DATA:
      state = {
        ...state,
        funnelChartData: payload,
      };
      break;
    case SET_TRAJET_REPORT_LOV_DATA:
      state = {
        ...state,
        lov: payload,
      };
      break;
    case SET_TRAJET_REPORT_BREADCRUMB_DATA:
      state = {
        ...state,
        breadcrumbData: payload,
      };
      break;
    case SET_TRAJET_REPORT_TEAM_LEAD_ASSIGNED_DATA:
      state = {
        ...state,
        teamLeadAssigned: payload,
      };
      break;
    default:
      break;
  }
  return state;
};

export default trajetReportReducers;
